import { act } from "react-dom/test-utils";
import { PAGE_HEADER_NAME } from "./actionType";

const initialState = {
    pageName: '',

};

const pageNameFn = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_HEADER_NAME:
       state = {
            ...state,
            pageName: action.payload,
          };
      break;  
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default pageNameFn;
